import actions from "~/shared/actions";
import type { Action } from "~/utils/actions";

export interface Country {
	code: string;
	name: string;
}

export type CountryState = Country[];

const defaultState: CountryState = [];

export default function countriesReducer(state = defaultState, action: Action): CountryState {
	switch (action.type) {
		case actions.COUNTRIES_RESPONSE:
			return action.data;
		default:
			return state;
	}
}
